var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProconAverageComplaintsSixMonths from '@/modules/search/components/filterPanels/ComplaintsPanel/ProconAverageComplaintsSixMonths.vue';
import { connect } from '@/overmind';
import { json } from 'overmind';
let ProconAverageComplaintsSixMonthsContainer = class ProconAverageComplaintsSixMonthsContainer extends Vue {
    constructor() {
        super(...arguments);
        // @ts-ignore
        this.values = json(this.inputValues);
    }
    onValuesChanged(newVal) {
        this.values = newVal;
        // @ts-ignore
        this.actionsSearch.searches.buildPotentialResults();
        // @ts-ignore
        this.setInputRangeProconAverageComplaintsSixMonths(newVal);
    }
};
__decorate([
    Prop({ default: () => { } })
], ProconAverageComplaintsSixMonthsContainer.prototype, "filter", void 0);
ProconAverageComplaintsSixMonthsContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        selected: state.totalSelected.complaints.proconAverageComplaintsSixMonths,
        inputValues: state.selectedInputRange['reclamacoes_procon.media_reclamacao_seis_meses'],
        setInputRangeProconAverageComplaintsSixMonths: actions.filters.setInputRangeProconAverageComplaintsSixMonths,
        actions: actions.filters,
        actionsSearch: actions.search,
    }), {
        components: { ProconAverageComplaintsSixMonths },
    }))
], ProconAverageComplaintsSixMonthsContainer);
export default ProconAverageComplaintsSixMonthsContainer;
